/** 直播 */
const LIVEING = '1'
/** 回放 */
const REPLAY = '2'
const LIVE_CAN_ACCESS = '1'

export { LIVE_CAN_ACCESS, LIVEING, REPLAY }
